import { createDefaultHonorWall, normalizeHonorWall } from "./honorWall";

const DEFAULT_SITE_CONFIG = {
  siteName: "山东尚亚信息科技有限公司",
  logoUrl: "",
  navItems: [
    { name: "首页", path: "/", visible: true },
    { name: "招商合作", path: "/investment", visible: true },
    { name: "产品中心", path: "/product", visible: true },
    { name: "经典案例", path: "/case", visible: true },
    { name: "走进尚亚", path: "/goin", visible: true },
    { name: "下载APP", path: "/download", visible: true }
  ],
  homeSlides: [
    {
      key: "welcome",
      title: "尚亚科技",
      subtitle: "",
      description: "立人立己 达人达己",
      backgroundUrl: ""
    },
    {
      key: "cases",
      title: "产品样例与经典案例",
      subtitle: "Successful Cases",
      description: "",
      backgroundUrl: ""
    },
    {
      key: "honor",
      title: "荣誉墙",
      subtitle: "Honor Wall",
      description: "",
      backgroundUrl: ""
    }
  ],
  honorWall: createDefaultHonorWall(),
  footerGroups: [
    { title: "走进尚亚", items: ["发展历程", "企业文化", "资质荣誉", "合作伙伴"] },
    { title: "招商合作", items: ["招商政策", "合作模式"] },
    { title: "产品中心", items: ["介绍视频", "管理模式", "平台目标", "功能模块", "流量速推", "刚好来商城"] }
  ]
};

function clone(value) {
  return JSON.parse(JSON.stringify(value));
}

function normalizeArray(value, fallback) {
  return Array.isArray(value) ? value : fallback;
}

export function mergeSiteConfig(config) {
  const source = config && typeof config === "object" ? config : {};
  const defaults = clone(DEFAULT_SITE_CONFIG);

  return Object.assign({}, defaults, source, {
    navItems: normalizeArray(source.navItems, defaults.navItems).map((item, index) => {
      const fallback = defaults.navItems[index] || {};
      return {
        name: item.name || fallback.name || "导航",
        path: item.path || fallback.path || "/",
        visible: item.visible !== false
      };
    }),
    homeSlides: defaults.homeSlides.map((slide, index) =>
      Object.assign({}, slide, normalizeArray(source.homeSlides, [])[index] || {})
    ),
    honorWall: normalizeHonorWall(source.honorWall),
    footerGroups: normalizeArray(source.footerGroups, defaults.footerGroups).map(group => ({
      title: group.title || "",
      items: normalizeArray(group.items, [])
    }))
  });
}

export function getDefaultSiteConfig() {
  return clone(DEFAULT_SITE_CONFIG);
}

export function requestJson(url, options = {}) {
  const requestOptions = Object.assign({}, options, {
    credentials: "same-origin",
    headers: Object.assign(
      { "Content-Type": "application/json" },
      options.headers || {}
    )
  });

  return fetch(url, requestOptions).then(async response => {
    const text = await response.text();
    const data = text ? JSON.parse(text) : null;
    if (!response.ok) {
      const message = data && data.message ? data.message : `请求失败：${response.status}`;
      throw new Error(message);
    }
    return data;
  });
}

export function loadSiteConfig() {
  return requestJson(`/site-config.json?t=${Date.now()}`).then(mergeSiteConfig);
}

export function loadEditableSiteConfig() {
  return requestJson(`/api/site-config?t=${Date.now()}`).then(mergeSiteConfig);
}

function adminHeaders() {
  return { Authorization: "Browser " + sessionStorage.getItem("token") };
}

export function saveSiteConfig(config) {
  return requestJson("/api/site-config", {
    method: "PUT",
    headers: adminHeaders(),
    body: JSON.stringify(mergeSiteConfig(config))
  }).then(mergeSiteConfig);
}

export function uploadSiteImage(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("读取图片失败"));
    reader.readAsDataURL(file);
  }).then(dataUrl =>
    requestJson("/api/upload-image", {
      method: "POST",
      headers: adminHeaders(),
      body: JSON.stringify({ fileName: file.name, dataUrl })
    })
  );
}
